import AgsPaytableComponent from "ags/components/ags-paytable-component";
import { PaginationMode } from "slotworks/components/ui/pagination-component";
import Layers from "slotworks/graphics/layers/layers";
import PaytableControl from "slotworks/smart-ui/controls/paytable-control";

export default class AgsPaytableControl extends PaytableControl {
    protected initPayTableComponent() {
        this.paytableComponent = new AgsPaytableComponent(Layers.PaytableContent, this.layer, "paytable", PaginationMode.PAGIFY);
    }
}